module.exports = __webpack_public_path__ + "img/qy (21).bf5ce6e3.jpg";